/**
 * El lenguaje de los filtros y las tarjetas de /propiedades. Copiado y no importado de
 * `map-search/ui/filtros.tsx`: el chat va en todas las páginas y aquel archivo arrastra
 * InstantSearch al paquete común.
 */

/** Un control: mismo alto, borde y letra que los desplegables del buscador. */
export const CONTROL = "rounded-md border border-gray-200 bg-white text-[13px] text-gray-900 shadow-xs"

/** `text-base` en móvil: con menos de 16 px, iOS amplía la página al enfocar el campo. */
export const CAMPO = `${CONTROL} h-9 w-full px-3 text-base md:text-[13px] outline-none placeholder:text-gray-400 focus:border-[#193144] disabled:opacity-50`

/** Como el botón de la tarjeta de propiedad. `text-white!` porque los enlaces traen color propio. */
export const BOTON =
  "flex h-9 w-full cursor-pointer items-center justify-center rounded-md bg-[#193144] text-xs font-medium text-white! transition-opacity hover:opacity-85 disabled:cursor-not-allowed disabled:opacity-50"
